import { render, staticRenderFns } from "./Cloud.vue?vue&type=template&id=34e0bf4a&scoped=true&"
import script from "./Cloud.vue?vue&type=script&lang=js&"
export * from "./Cloud.vue?vue&type=script&lang=js&"
import style0 from "./Cloud.vue?vue&type=style&index=0&id=34e0bf4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e0bf4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
